import React, { useContext, useEffect, useState } from 'react';
import { IColumn } from  '@/interfaces/IContentTable';
import { Truncate } from  '@/helpers/Text';
import { numberFormatter } from  '@/helpers/Numbers';
import ModalWrapper from  '@/components/modals/ModalWrapper';
import { FilterPage, IDirectionStats, NumberDirection } from  '@/interfaces/insightsp2';
import DirectionIcon from './DirectionIcon';
import { BuildPath } from  '@/helpers/Paths';
import { IInsightsContext, InsightsContext } from '@/context/InsightsContext';
import Icon from '../icons/Icons';
import { IconLibrary } from  '@/interfaces/IconLibrary';

type Props = {
    columnsFiltered:IColumn[], 
    data:any, 
    val:string,
    detailsModal?:boolean
}

const CellContent = ({columnsFiltered, data, val, detailsModal}:Props) => {

    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [showStatsDetails, setShowStatsDetails] = useState<boolean>(false);
    const [directionStats, setDirectionStats] = useState<IDirectionStats>(null);

    const context:IInsightsContext = useContext(InsightsContext);

    const label = columnsFiltered.filter(x => x.field === val);
    let itemType = "";
    let value = data[val];
    let fullTitle = "";
    let uri = "";

    useEffect(() => {

        // Create modal
        if (detailsModal && data.id.hasOwnProperty('directionStats')){

            setShowStatsDetails(true);

            setDirectionStats(data.id.directionStats)
        }

    });

    const Image = ():JSX.Element => {

        if (context.filterPage === FilterPage.users){
            return(
                <img src={`${BuildPath()}/images/insightsp2/peopleGroup.svg`} alt="" />
            )
        }

        return  <img src={data.image === "" || data.image === null ? `${BuildPath()}/images/missingimage.png` : data.image} alt="" />
    }

    // Extract url
    if (value.hasOwnProperty("uri") && value.hasOwnProperty("label")){
        uri = value["uri"];
        value = value["label"]; 
    }

    if (!isNaN(value)){
        
        // Dont number format for these fields
        if (!['title', 'widget', 'channel'].find(x => x === label[0].field)){
            value = numberFormatter(value);
        } 
    }

    try {
        if (label[0].field === "title"){
            itemType = "title";
        }
        else if (label[0].field === "channel"){
            itemType = "channel";
        }
    }
    catch(err) {
        console.log(`Cell content error: ${err}`)
    }

    if (label.length && label[0].maxChars){    
        
        //if (itemType === "title"){
            fullTitle = Truncate(value, 100);      
        //}
        
        value = Truncate(value, label[0].maxChars) 
    }

    function itemClick(field:string):void {
        
        if (field !== "title") return;

        // Modal content
        if (showStatsDetails){
            setModalOpen(true)
        }
        // Link
        else if (uri !== ""){
            window.location.href = uri;
        }
    }

    function noClick():boolean {

        return !showStatsDetails && uri === "" && itemType === "title";


    }

    const TitleTooltip = ({itemType, title}: {itemType:string, title:string}):JSX.Element => {

        if (itemType !== "title" && itemType !== "channel"){
            return <></>;
        }

        return (
            <div className="tooltiptext">{title}</div>
        )
    }


    return (

        <>
            <div className="cell-padding intooltip" >
                <TitleTooltip itemType={itemType} title={fullTitle}/>

                {label[0].icon && label[0].label !== "Likes" && <img src={label[0].icon} className="tbl-icon" alt={label[0].label} />}
                
                {label[0].icon && label[0].label === "Likes" && <Icon iconName={IconLibrary.LIKE_ACTIVE} className="tbl-icon" sizeInPx='12' color='var(--thriveCMSTextEmphasisColor)'/>}
                
                <span className={`${itemType} ${noClick() ? 'no-click':''}`} onClick={() => itemClick(itemType)}>{value}</span>
            </div>

            {showStatsDetails && 
                <ModalWrapper isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} className="content-details">
                        
                    <h2>{context.filterPage === FilterPage.users ? 'User Group Details' : 'Content Item Details'}</h2>

                    <div className="details-container">
                        <div className={context.filterPage === FilterPage.users ? 'image user-group-image' : 'image'}>
                           <Image />
                        </div>
                        <div className="content">
                            <ul>
                                <li><span>{context.filterPage === FilterPage.users ? 'Group Name' : 'Title'}:</span>&nbsp;{data.title.hasOwnProperty("label") ? data.title.label : data.title}</li>
                                <li><span>Leaderboard Position:</span>&nbsp;{directionStats.leaderBoardPosition}</li>

                                {data.id.hasOwnProperty('directionStats') && data.id.directionStats.hasOwnProperty('positionsMoved') && 
                                    <li className="positionsMoved">
                                        <span>Positions moved:</span>&nbsp;
                                        <DirectionIcon numberDirection={directionStats.direction} />&nbsp;
                                        {directionStats.direction !== NumberDirection.new && directionStats.positionsMoved}
                                    </li>
                                }
                                
                            </ul>
                        </div>
                    </div>

                </ModalWrapper>
            }
        </>  

    );
};

export default CellContent;